/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  // NOTICE: KAPTION-INTEGRATION - Widget content translation API
  translateWidgetContent(inboxId, { primary_locale, target_locales }) {
    return axios.post(`${this.url}/${inboxId}/translate_widget_content`, {
      primary_locale,
      target_locales,
    });
  }

  // NOTICE: KAPTION-INTEGRATION - WhatsApp coexistence history sync
  getWhatsappHistorySync(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_history_sync`);
  }

  triggerWhatsappHistoryTranslation(inboxId) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_history_sync/trigger_translation`
    );
  }
}

export default new Inboxes();
